<div class="card attn" [class.clear]="isClear">
  <div class="attn-eyebrow">{{ eyebrow }}</div>

  <ng-container *ngIf="hasGoals; else noGoals">
    <h2 class="attn-head">{{ headline }}</h2>
    <div class="attn-sub" *ngIf="!hasGoals">{{ sub }}</div>

    <div class="attn-list" *ngIf="attention.length; else allClear">
      <button
        class="attn-item"
        *ngFor="let item of attention"
        (click)="onItemClick(item)"
      >
        <span class="dot" [class.amber]="item.dotClass === 'amber'" [class.red]="item.dotClass === 'red'" [class.green]="item.dotClass === 'green'"></span>
        <span>
          <b>{{ item.title }}</b>
          <span class="why">{{ item.why }}</span>
        </span>
        <span class="go">{{ item.linkTo === 'tasks' ? 'View tasks' : 'Open goal' }} &rarr;</span>
      </button>
    </div>

    <ng-template #allClear>
      <div class="attn-clear-msg">
        <span class="dot green"></span>
        <span>You're on track across all goals</span>
        <span *ngIf="!hasGoals"> &mdash; here's what's coming up.</span>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #noGoals>
    <div class="no-goals-msg">
      <span class="material-icons no-goals-icon">assignment_late</span>
      <div class="no-goals-title">No goals assigned for the selected quarter.</div>
      <div class="no-goals-sub">Please reach out to your Regional Manager if goals need to be added.</div>
    </div>
  </ng-template>

  <div class="stats" *ngIf="hasGoals">
    <div class="stat" *ngFor="let stat of stats">
      <div class="k">{{ stat.label }}</div>
      <div class="v" *ngIf="stat.value || stat.suffix">{{ stat.value | number:'1.0-2' }}<span *ngIf="stat.suffix" class="v-suffix">{{ stat.suffix }}</span></div>
      <div class="pill-row" *ngIf="stat.pills && stat.pills.length">
        <span class="mini" *ngFor="let pill of stat.pills" [class.g]="pill.class === 'g'" [class.a]="pill.class === 'a'" [class.r]="pill.class === 'r'">{{ pill.label }}</span>
      </div>
      <div class="d" *ngIf="stat.detail && !stat.pills" [class.up]="stat.detailClass === 'up'" [class.down]="stat.detailClass === 'down'">{{ stat.detail }}</div>
    </div>
  </div>
  <div class="refreshed" *ngIf="refreshedAt">Data last refreshed {{ refreshedAt }}</div>
</div>
